import React from 'react';
import { Table } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/rootReducer';
import { RepaymentInfo } from '../../Investments/redux/types';
import HSButton from '../../../common/Button';
import RemarksModal from '../modal/Remarks';

const RepaymentTable: React.FC = () => {
    const repayments = useSelector((state: RootState) => state.investments.repayment?.repayments);

    const statusButton = (record: RepaymentInfo) => {
        switch (record.dealRepayment.status) {
            case 'PAID':
                return (
                    <HSButton
                        title="PAID"
                        style={{ backgroundColor: 'green', borderColor: 'green', minHeight: 'auto' }}
                    />
                );
            case 'LATE':
                return (
                    <HSButton
                        title="LATE"
                        style={{ backgroundColor: 'white', borderColor: 'red', color: '#000', minHeight: 'auto' }}
                    />
                );
            case 'UPCOMING':
                return (
                    <HSButton
                        title="UPCOMING"
                        style={{
                            backgroundColor: 'white',
                            borderColor: '#16365c',
                            color: '#16365c',
                            minHeight: 'auto',
                        }}
                    />
                );
            default:
                return null;
        }
    };

    const columns = [
        {
            title: 'Date',
            dataIndex: '',
            render: (record: RepaymentInfo) => (
                <span>{record.dealRepayment.date && record.dealRepayment.date.date}</span>
            ),
        },
        {
            title: 'Expected Repayment',
            dataIndex: '',
            render: (record: RepaymentInfo) => (
                <span>
                    {(record.investmentRepayment.expectedAmount &&
                        `${record.investmentRepayment.expectedAmount.currency} ${
                            record.investmentRepayment.expectedAmount.amountUpto2dp?.toLocaleString() || 0
                        }`) ||
                        '-'}
                </span>
            ),
        },
        {
            title: 'Actual Repayment',
            dataIndex: '',
            render: (record: RepaymentInfo) => (
                <span>
                    {(record.investmentRepayment.actualAmount &&
                        `${record.investmentRepayment.actualAmount.currency} ${
                            record.investmentRepayment.actualAmount.amountUpto2dp?.toLocaleString() || 0
                        }`) ||
                        '-'}
                </span>
            ),
        },
        {
            title: 'Fee',
            dataIndex: '',
            render: (record: RepaymentInfo) => (
                <span>
                    {(record.investmentRepayment.fee &&
                        `${record.investmentRepayment.fee.currency} ${
                            record.investmentRepayment.fee.amountUpto2dp?.toLocaleString() || 0
                        } `) ||
                        '-'}
                </span>
            ),
        },
        {
            title: 'Net Actual Repayment',
            dataIndex: '',
            render: (record: RepaymentInfo) => (
                <span>
                    {(record.investmentRepayment.actualAmount &&
                        `${record.investmentRepayment.actualAmount.currency} ${(
                            (record.investmentRepayment.actualAmount.amountUpto2dp || 0) -
                            (record.investmentRepayment.fee.amountUpto2dp || 0)
                        ).toLocaleString()} `) ||
                        '-'}
                </span>
            ),
        },
        {
            title: 'Status',
            dataIndex: '',
            render: (record: RepaymentInfo) => <span>{statusButton(record)}</span>,
        },
        {
            title: 'Remarks',
            dataIndex: '',
            render: (record: RepaymentInfo) => (
                <>
                    {record.dealRepayment.remarks && record.dealRepayment.remarks.length > 0 ? (
                        <RemarksModal list={record.dealRepayment.remarks || []} />
                    ) : (
                        <span>-</span>
                    )}
                </>
            ),
        },
    ];

    return (
        <div className="rounded-md overflow-hidden shadow-lg bg-white h-full relative m-auto mt-4 w-full">
            <div className="px-4 py-4">
                <p className="text-lg pb-4 SourceSansPro-SemiBold">Repayments</p>
                <Table
                    rowClassName={'table-row-dark'}
                    columns={columns}
                    dataSource={repayments || []}
                    className="w-full overflow-auto"
                    pagination={false}
                    scroll={{ y: 400 }}
                    rowKey={(record) => `${record.investmentRepayment.uuid}_${record.dealRepayment.uuid}_repayment`}
                />
            </div>
        </div>
    );
};

export default RepaymentTable;
